const THAI = /[฀-๿]/;

/**
 * `lang` for a free-text block (citizen reports, headlines, building names):
 * "th" when it contains Thai script, else undefined (inherit the page's "en").
 * WCAG 3.1.2 — screen readers switch voice, browsers pick Thai line-breaking.
 */
export function langOf(text: string | null | undefined): "th" | undefined {
  return text && THAI.test(text) ? "th" : undefined;
}
